import { useEffect } from "react"
import { useQueryClient } from "@tanstack/react-query"
import { useRoutes } from "./routes"
import { ToastContainer } from "react-toastify"
import { useAuth } from "hooks/api/auth/auth.hook"
import { startQuotationCacheSync } from "helpers/quotationWindowSync.helper"
import { useViewerAssetPreload } from "hooks/viewerAssetPreload.hook"
import "./assets/scss/style.scss"

export const App = () => {
	const { isAuthenticated } = useAuth()
	const routes = useRoutes(isAuthenticated)
	const queryClient = useQueryClient()

	// Keep this window's quotation cache in step with any sibling window (#1430, requirement 3).
	// Started app-wide rather than inside the editor because BOTH sides need it — the main app and
	// the popped-out window are the same `App`, and either can be the one that mutates. With no
	// sibling on the channel it costs one idle BroadcastChannel.
	useEffect(() => startQuotationCacheSync(queryClient), [queryClient])

	// Pull Apryse's shared bundles/wasm/fonts into the HTTP cache while the app is idle, so the
	// first quotation viewer open doesn't download them after the click.
	useViewerAssetPreload(isAuthenticated)

	return (
		<>
			{routes}
			<ToastContainer />
		</>
	)
}
